import { APP_TOP_BAR_ROW_HEIGHT } from '../../../constants/app-top-bar-layout'

export const ARC_HEIGHT = 25
export const DAILY_TIP_HEADER_EXPANDED_HEIGHT = 260 - ARC_HEIGHT
export const DAILY_TIP_HEADER_COLLAPSED_HEIGHT = APP_TOP_BAR_ROW_HEIGHT
